import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import { Elements } from '@stripe/react-stripe-js';
import awsConfig from './aws-config';
import stripePromise from './stripe-config';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './components/Home';
import Signup from './components/Signup';
import Login from './components/Login';
import Plans from './components/Plans';

import Setup from './components/Setup';
import OperationalDashboard from './components/OperationalDashboard';
import Privacy from './components/Privacy';
import TermsOfConditions from './components/TermsOfConditions';
import BetaAvailabilityModal from './components/BetaAvailabilityModal';
import { useBetaAvailability } from './hooks/useBetaAvailability';
import { useAuth } from './contexts/AuthContext';
import './test-logging';
import './debug-auth';
import './test-voice-api';

Amplify.configure(awsConfig);

// Add OAuthCallback route for proper OAuth handling
import OAuthCallback from './components/OAuthCallback';

function AppContent() {
  const { user } = useAuth();
  const { showBetaModal, closeBetaModal } = useBetaAvailability();

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/plans" element={
          <ProtectedRoute>
            <Plans />
          </ProtectedRoute>
        } />
        <Route path="/pricing" element={
          <ProtectedRoute>
            <Plans />
          </ProtectedRoute>
        } />
        <Route path="/setup" element={
          <ProtectedRoute>
            <Setup />
          </ProtectedRoute>
        } />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <OperationalDashboard />
          </ProtectedRoute>
        } />

        <Route path="/privacy" element={<Privacy />} />
        <Route path="/toc" element={<TermsOfConditions />} />
        <Route path="/oauth/callback" element={<OAuthCallback />} />
      </Routes>
      
      <BetaAvailabilityModal 
        isOpen={showBetaModal}
        onClose={closeBetaModal}
        email={user?.attributes?.email}
      />
    </>
  );
}

function App() {
  return (
    <Elements stripe={stripePromise}>
      <AuthProvider>
        <Router>
          <AppContent />
        </Router>
      </AuthProvider>
    </Elements>
  );
}

export default App;